import SupporterActionTypes, * as actionDicts from "shared/profiles/supporter/supporter-profile-action-types"
import * as djangioActionCreators from "shared/djangio/action-creators"
import * as descriptionActionCreators from "shared/state_management/action-creators"
import { loadCustomFields } from "shared/customFields/action-creators"
import { loadSocialUsersFromSupporter } from "shared/social/social-user-action-creators"
import { attachActionHandlers } from "shared/profiles/constants/helperFunctions"

const { NewSupporter } = DjangIO.app.grassroots.models

export const loadSupporter = (id) =>
    djangioActionCreators.resourceGetDetail(
        NewSupporter.objects.filter({
            full_dehydrate_public_organization: true,
            ...{ full_dehydrate_public_organizations: true },
            full_dehydrate_last_user: true,
            dehydrate_extra: [
                "action_center_source",
                "action_center_interactions",
                "registration_page_source",
                "registration_page_interactions",
                "gamification_stats",
                "individuals_information",
                "charity_name",
                "charity_ein",
                "charity_address",
                "pac_account_information",
            ].filter((item) => item),
        }),
        actionDicts.loadSupporterActionDict,
        id,
        { id },
    )

export const getBusinessCards = (id) =>
    djangioActionCreators.resourceGetList(
        DjangIO.app.grassroots.models.BusinessCard,
        actionDicts.loadBusinessCardActionDict,
        { supporter: id },
        { id },
    )

export const fetchPotentialDuplicates = (supporterId) => {
    const filters = {
        get_potential_duplicates_from_datum_id: supporterId,
        archived: false,
        data_type: DjangIO.app.models.QuorumDataType.supporter.value,
    }
    return djangioActionCreators.resourceGetList(
        DjangIO.app.deduplication.models.PotentialDuplicate,
        actionDicts.loadPotentialDuplicatesActionDict,
        filters,
        { id: supporterId },
    )
}

export const removeProfileRow = (parentId, datumId) => (dispatch) =>
    dispatch({ type: SupporterActionTypes.REMOVE_POTENTIAL_DUPLICATE_OBJECT, parentId, id: datumId })

export const loadData =
    // On the current contact form (static/frontend/components/), when we go to the Edit page,
    // make a change and are redirected to the contact page,
    // the info displayed on screen already have the new info as we were using Redux.
    // Reloading the information was not needed as we relayed on Redux States,
    // so this logic was implemented to prevent unnecessary calls to the API.
    // Now, for the new form (frontend/pages/edit-contact/index.tsx),
    // as we don't use Redux, to see the changes reflected on the contact page, we need to reload the information.
    // So that is the reason we are removing the logic.


        (id, handlers = {}) =>
        (dispatch) => {
            dispatch(
                attachActionHandlers({
                    loadActionCreator: loadSupporter,
                    profileId: id,
                    handlers,
                }),
            )
            dispatch(getBusinessCards(id))
            dispatch(loadSocialUsersFromSupporter(id))
            dispatch(loadCustomFields(Userdata.organization_id))
            dispatch(fetchPotentialDuplicates(id))
            return dispatch(
                descriptionActionCreators.loadDataDescription({
                    qdt: DjangIO.app.models.QuorumDataType.supporter,
                    id,
                }),
            )
        }

export const updateCustomTagDict = (newTagDictValues) => ({
    type: SupporterActionTypes.UPDATE_SUPPORTER_TAG_DICT,
    newTagDictValues,
})

export const loadSupporterTransactionSummary = (id, ledgerSettingsIds) =>
    djangioActionCreators.sendAction(
        DjangIO.app.ledger.models.Transaction,
        actionDicts.loadSupporterTransactionSummaryActionDict,
        {
            action: "transactions_summary",
            method: "get",
            kwargs: {
                supporter: [id],
                ledger_settings: ledgerSettingsIds,
                transaction_type: [DjangIO.app.ledger.types.TransactionType.money_received.value],
            },
            payload: {
                id,
            },
        },
    )

/**
 * Update the amount of gamification points a Supporter has
 * @param {int} id - the id of the Supporter
 * @param {int} points - the amount of points that need to be added
 */
export const updatePoints = (id, points) => ({
    type: SupporterActionTypes.UPDATE_SUPPORTER_POINTS,
    id,
    points,
})
